(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const dialog = root.querySelector('dialog');
    let opener;
    let activeIndex = 0;
    const selectMedia = index => {
      if (!slides.length) return;
      index = (index + slides.length) % slides.length;
      activeIndex = index;
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const counter = root.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      const rail = root.querySelector('.zp-thumbs');
      const thumb = thumbs[index];
      if (rail && thumb) rail.scrollLeft = thumb.offsetLeft - rail.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2;
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectMedia(index)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => selectMedia(activeIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => selectMedia(activeIndex + 1));
    const gallery = root.querySelector('.zp-gallery');
    gallery?.addEventListener('keydown', event => {
      if (!event.target.closest('[data-zoom], [data-thumb], [data-gallery-prev], [data-gallery-next]')) return;
      if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      selectMedia(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      if (event.target.matches('[data-thumb]')) thumbs[activeIndex]?.focus();
      if (event.target.matches('[data-zoom]')) slides[activeIndex]?.querySelector('[data-zoom]')?.focus();
    });
    const stage = root.querySelector('.zp-stage');
    let touchStart;
    let suppressZoomUntil = 0;
    stage?.addEventListener('touchstart', event => {
      if (event.touches.length !== 1 || !event.target.closest('[data-zoom]')) { touchStart = null; return; }
      touchStart = {x:event.touches[0].clientX, y:event.touches[0].clientY};
    }, {passive:true});
    stage?.addEventListener('touchend', event => {
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        suppressZoomUntil = Date.now() + 500;
        selectMedia(activeIndex + (dx < 0 ? 1 : -1));
      }
    }, {passive:true});
    stage?.addEventListener('touchcancel', () => { touchStart = null; }, {passive:true});
    root.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {
      if (Date.now() < suppressZoomUntil) return;
      const image = button.querySelector('img');
      const large = dialog.querySelector('img');
      large.src = image.src;
      large.srcset = image.srcset;
      large.sizes = '90vw';
      large.alt = image.alt;
      opener = button;
      dialog.showModal();
    }));
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => opener?.focus());

    const tabs = [...root.querySelectorAll('[data-pay]')];
    const setTab = tab => {
      tabs.forEach(item => {
        item.setAttribute('aria-selected', String(item === tab));
        item.tabIndex = item === tab ? 0 : -1;
      });
      root.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.pay; });
    };
    tabs.forEach((tab,index) => {
      tab.addEventListener('click', () => setTab(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); setTab(tabs[next]); tabs[next].focus(); }
      });
    });
    const sticky = root.querySelector('[data-sticky]');
    const buy = root.querySelector('.zp-buy');
    const observer = new IntersectionObserver(entries => {
      sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0;
    }, {threshold:0});
    observer.observe(buy);
    root.querySelector('.zp-assurance a')?.addEventListener('click', () => {
      root.querySelector('[id^="zp-warranty-"]').open = true;
    });
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const currency = document.documentElement.getAttribute('data-currency') || window.Shopify?.currency?.active || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(cents/100);
    root.querySelector('[data-variant]')?.addEventListener('change', event => {
      const variant = variants.find(item => String(item.id) === event.target.value);
      if (!variant) return;
      root.querySelector('[data-price]').textContent = money(variant.price);
      root.querySelector('[data-sticky-price]').textContent = money(variant.price);
      const compare = root.querySelector('[data-compare]');
      const saving = root.querySelector('[data-saving]');
      compare.hidden = saving.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = money(variant.compare_at_price || 0);
      saving.textContent = (root.dataset.labelSave || 'Save') + ' ' + money((variant.compare_at_price || 0) - variant.price);
      root.querySelector('[data-stock]').textContent = variant.available ? '● ' + (root.dataset.labelAvailable || 'Available to order') : (root.dataset.labelUnavailable || 'Currently sold out');
      root.querySelector('[data-submit]').disabled = !variant.available;
      root.querySelector('[data-submit-label]').textContent = variant.available ? (root.dataset.labelAdd || 'Add to cart') : (root.dataset.labelSoldout || 'Sold out');
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({},'',url);
      if (variant.featured_media) { const index = slides.findIndex(slide => slide.querySelector('img')?.src.includes(variant.featured_media.preview_image?.src?.split('/').pop()?.split('?')[0])); if (index >= 0) selectMedia(index); }
    });
  }
  document.querySelectorAll('[data-zero-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-zero-product]').forEach(init));
})();
